import type { PropsWithChildren } from "react";

import { ThemeProvider } from "@emotion/react";

import { theme } from "../theme/theme";

export function StackletUIThemeProvider({ children }: PropsWithChildren) {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
